import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'qt-ai-chat-thinking-block',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
  template: `
    <div class="ai-chat-thinking-block">
      <div
        class="ai-chat-thinking-block__container"
        [matTooltip]="content()"
        matTooltipPosition="above"
        matTooltipClass="ai-chat-thinking-tooltip">
        <mat-icon class="ai-chat-thinking-block__icon">psychology</mat-icon>
      </div>
    </div>
  `,
  styleUrls: ['./ai-chat-thinking-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiChatThinkingBlockComponent {
  // Signal-based input
  readonly content = input.required<string>();
}
